
class LinkService {
  getLink() {
    // return 'http://localhost:8081'
    return 'https://api.exam-proctor.ponnipa.in.th'
  }
}

export default new LinkService();